export default "__VITE_ASSET__BSau_hzx__"